export default __webpack_public_path__ + "static/media/order.d8c07495.svg";